<template>
  <div>

    <div class="sayfahead">
      <h1>{{ Damga }} {{ SayfaAdi }}</h1>

      <el-button-group v-if="Kasa" class="float-right">
        <a @click="Yazdir" class="el-button YeniBtn el-button--primary el-button--small"
        ><i class="feather-printer"></i> Yazdır
        </a>
      </el-button-group>
    </div>
    <div class="icerik">
      <Yukleniyor :data="lo"></Yukleniyor>
      <div class="raporbloksabitle">
        <el-row :gutter="24">
          <el-form
            @submit.prevent.native="Calistir"
            ref="RaporForm">
            <el-col :span="4">
              <el-form-item label="Tarih" prop="Tarih">
                <el-date-picker
                  v-model="Tarih"
                  type="date"
                  placeholder=""
                  format="dd.MM.yyyy">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="Sorgu Türü" prop="Tur">
                <el-select v-model="Tur" filterable>
                  <el-option
                    value="1"
                    label="İşlem Tarihine Göre">
                  </el-option>
                  <el-option
                    value="2"
                    label="Ödeme Tarihine Göre">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="3" :offset="13">
              <el-button type="primary" class="btn-block mt-3" size="medium" @click="Calistir"
                         icon="el-icon-check">Rapor Oluştur
              </el-button>
            </el-col>
          </el-form>
        </el-row>
      </div>
      <el-alert
        v-if="!Kasa"
        title="Filtreleme Yapınız"
        type="info"
        :closable="false"
        description="Verilere erişebilemek için lütfen filtreleme yapınız"
      >
      </el-alert>
      <table v-for="(k,i) in Kasa" class="table table-bordered table-hover yazdirma">
        <thead>
        <tr>
          <th class="text-center" colspan="6">{{ i }}</th>
        </tr>
        <tr>
          <th>Kasa</th>
          <th class="text-right">Gelir</th>
          <th class="text-right">Tahsil Zam</th>
          <th class="text-right">Gider</th>
          <th class="text-right">Virman</th>
          <th class="text-right">Bakiye</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(ka,ia) in k">
          <td>{{ ia }}</td>
          <td class="text-right">{{ ka.Tahsilat }}</td>
          <td class="text-right">{{ ka.tZam }}</td>
          <td class="text-right">{{ ka.Gider }}</td>
          <td class="text-right">{{ ka.Virman }}</td>
          <td class="text-right">{{ ka.Bakiye }}</td>
        </tr>
        </tbody>
      </table>
      <div class="yazdirtable">
        <h1>{{ Damga }} {{ SayfaAdi }}</h1>
        <table v-for="(k,i) in Kasa" class="table table-bordered table-hover">
          <thead>
          <tr>
            <th class="text-center" colspan="6">{{ i }}</th>
          </tr>
          <tr>
            <th>Kasa</th>
            <th class="text-right">Gelir</th>
            <th class="text-right">Tahsil Zam</th>
            <th class="text-right">Gider</th>
            <th class="text-right">Virman</th>
            <th class="text-right">Bakiye</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(ka,ia) in k">
            <td>{{ ia }}</td>
            <td class="text-right">{{ ka.Tahsilat }}</td>
            <td class="text-right">{{ ka.tZam }}</td>
            <td class="text-right">{{ ka.Gider }}</td>
            <td class="text-right">{{ ka.Virman }}</td>
            <td class="text-right">{{ ka.Bakiye }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Yukleniyor from "../../../components/Doc/Yukleniyor";

export default {
  components: {Yukleniyor},
  data() {
    return {
      lo: false,
      Tur: '1',
      tableDisplay: false,
      SayfaAdi: 'Günsonu',
      Kasa: null,
      Damga: null,
      Tarih: new Date(),
    }
  },
  methods: {
    Yazdir() {
      window.print()
    },
    Calistir() {
      this.lo = true;
      this.$store.dispatch("Post", {Tarih: this.Tarih, Tur: this.Tur, path: 'raporlama/gunsonu'})
        .then(response => {
          this.lo = false;
          if (response.Durum == "OK") {
            this.Kasa = response.Kasa;
            this.Damga = response.Damga;
            if (this.Kasa) this.tableDisplay = true;
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Raporlama/ozel/gunsonu.vue